"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var react_apollo_1 = require("react-apollo");
var graphql_tag_1 = require("graphql-tag");
var I18n = require("i18n-js");
var modal_1 = require("@reverbdotcom/commons/dist/components/modal");
var modal_sidebar_listing_1 = require("@reverbdotcom/commons/dist/components/modal_sidebar_listing");
var auto_offer_form_1 = require("./auto_offer_form");
var modal_sidebar_listing_operations_1 = require("@reverbdotcom/commons/dist/components/modal_sidebar_listing_operations");
var offer_operations_1 = require("@reverbdotcom/commons/dist/offers/offer_operations");
function AutoOfferListingDetails(props) {
    if (props.data.loading || !props.data.listing)
        return null;
    return [
        {
            term: I18n.t('commons.offers.sidebar.condition'),
            definition: props.data.listing.condition.displayName,
        },
        {
            term: I18n.t('commons.offers.sidebar.sellerCost'),
            definition: props.data.listing.sellerPrice.display,
        },
        {
            term: I18n.t('commons.offers.sidebar.askingPrice'),
            definition: props.data.listing.price.display,
        },
        {
            term: I18n.t('commons.offers.sidebar.watches'),
            definition: props.data.listing.counts.watchers,
        },
    ];
}
exports.AutoOfferListingDetails = AutoOfferListingDetails;
function AutoOfferModal(props) {
    return (React.createElement(modal_1.default, { isOpen: props.modalIsOpen, paddedBody: true, newClose: true, headerTitle: I18n.t('commons.offers.autoOffers'), onRequestClose: function () { return props.onModalClose(); }, sidebarContent: React.createElement(modal_sidebar_listing_1.default, { loading: props.data.loading, listing: props.data && props.data.listing, details: AutoOfferListingDetails(props) }) },
        React.createElement(auto_offer_form_1.default, { listingId: props.listingId, closeModal: props.onModalClose })));
}
exports.AutoOfferModal = AutoOfferModal;
var connected = react_apollo_1.graphql(graphql_tag_1.default(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n    query Core_AutoOfferModal($listingId: String) {\n      listing(input: { id: $listingId }) {\n        ...ModalSidebarListingFragment\n        ...AutoOfferListingFragment\n      }\n    }\n    ", "\n    ", "\n  "], ["\n    query Core_AutoOfferModal($listingId: String) {\n      listing(input: { id: $listingId }) {\n        ...ModalSidebarListingFragment\n        ...AutoOfferListingFragment\n      }\n    }\n    ", "\n    ", "\n  "])), modal_sidebar_listing_operations_1.ModalSidebarListingFragment, offer_operations_1.AutoOfferListingFragment));
exports.default = connected(AutoOfferModal);
var templateObject_1;
//# sourceMappingURL=auto_offer_modal.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/listings/auto_offer_modal.js
// module id = TRU0
// module chunks = 20 21